// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: whitesmoke;
}

/* styles.css */
.heading-box {
  text-align: left;
  background-color: #F1F1F1;
  border: solid 1px #d4d4d4;
  margin-bottom: 50px;
  background-color: #187a9b;
  color: white;
  padding: 10px;
  border-radius: 5px 5px 0 0;
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.CurrentDesignee {
  border: 2px solid #286090;
  width: 100%;
  margin: 5% auto;
  border-radius: 10px;
  background-color: #fff;
  padding-bottom:2% auto;
}

.search-button {
  background-color: #187a9b;
  color: white;
  padding: 3px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}

.search-button:disabled {
  background-color: #187a9b;
  cursor: not-allowed;
}



/* General table styles */
table {
  border-collapse: collapse;
  width: 100%;

}

th,
td {
  border: 1px solid grey;
  padding: 2px;
  text-align: center;
  height: 30px;
}

th {
  background-color: #f2f2f2;
}

/* Specific styles for the nested table */
.heading-box+table {
  border: 1px solid grey;
}

.heading-box+table th,
.heading-box+table td {
  border: 1px solid grey;
  padding: 5px;
  text-align: center;
  height: 10px;
}




/* Modal styles */
.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: transparent;
}

.modal-content {
  background-color: #fefefe;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
  max-width: 500px;
  height: auto;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}


/* OK button styles */
#closeSuccessModal {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  text-align: right;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  margin: 10px 0;
  cursor: pointer;
  border-radius: 4px;
  position: absolute;
  right: 20px;
  bottom: 20px;
}

#closeSuccessModal:hover {
  background-color: #0056b3;
}
.currentdesignee-select-text {
  color: white;
  padding: 10px;
  background-color: #286090;
  text-align: left;
  border-radius: 5px 5px 0 0;
}

:host {
  font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
}
.designee-message {
  color: red;
  text-align: right;
  margin-top: 10px; /* Adjust as needed */
}
.table{
  padding-left: 2%;
  padding-right: 2%;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRlbXBvcmFyeS1kb2EtZGVzaWduZWUuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLDRCQUE0QjtBQUM5Qjs7QUFFQSxlQUFlO0FBQ2Y7RUFDRSxnQkFBZ0I7RUFDaEIseUJBQXlCO0VBQ3pCLHlCQUF5QjtFQUN6QixtQkFBbUI7RUFDbkIseUJBQXlCO0VBQ3pCLFlBQVk7RUFDWixhQUFhO0VBQ2IsMEJBQTBCO0VBQzFCLGNBQWM7RUFDZCxXQUFXO0VBQ1gsc0JBQXNCO0FBQ3hCOztBQUVBO0VBQ0UseUJBQXlCO0VBQ3pCLFdBQVc7RUFDWCxlQUFlO0VBQ2YsbUJBQW1CO0VBQ25CLHNCQUFzQjtFQUN0QixzQkFBc0I7QUFDeEI7O0FBRUE7RUFDRSx5QkFBeUI7RUFDekIsWUFBWTtFQUNaLGlCQUFpQjtFQUNqQixrQkFBa0I7RUFDbEIsZUFBZTtFQUNmLGlCQUFpQjtBQUNuQjs7QUFFQTtFQUNFLHlCQUF5QjtFQUN6QixtQkFBbUI7QUFDckI7Ozs7QUFJQSx5QkFBeUI7QUFDekI7RUFDRSx5QkFBeUI7RUFDekIsV0FBVzs7QUFFYjs7QUFFQTs7RUFFRSxzQkFBc0I7RUFDdEIsWUFBWTtFQUNaLGtCQUFrQjtFQUNsQixZQUFZO0FBQ2Q7O0FBRUE7RUFDRSx5QkFBeUI7QUFDM0I7O0FBRUEseUNBQXlDO0FBQ3pDO0VBQ0Usc0JBQXNCO0FBQ3hCOztBQUVBOztFQUVFLHNCQUFzQjtFQUN0QixZQUFZO0VBQ1osa0JBQWtCO0VBQ2xCLFlBQVk7QUFDZDs7Ozs7QUFLQSxpQkFBaUI7QUFDakI7RUFDRSxhQUFhO0VBQ2IsZUFBZTtFQUNmLFVBQVU7RUFDVixTQUFTO0VBQ1QsUUFBUTtFQUNSLGdDQUFnQztFQUNoQyxXQUFXO0VBQ1gsWUFBWTtFQUNaLGNBQWM7RUFDZCw2QkFBNkI7QUFDL0I7O0FBRUE7RUFDRSx5QkFBeUI7RUFDekIsWUFBWTtFQUNaLGFBQWE7RUFDYixzQkFBc0I7RUFDdEIsVUFBVTtFQUNWLGdCQUFnQjtFQUNoQixZQUFZO0VBQ1osaUJBQWlCO0VBQ2pCLGdCQUFnQjtFQUNoQiw0RUFBNEU7QUFDOUU7OztBQUdBLHFCQUFxQjtBQUNyQjtFQUNFLHlCQUF5QjtFQUN6QixZQUFZO0VBQ1osWUFBWTtFQUNaLGlCQUFpQjtFQUNqQixpQkFBaUI7RUFDakIscUJBQXFCO0VBQ3JCLHFCQUFxQjtFQUNyQixlQUFlO0VBQ2YsY0FBYztFQUNkLGVBQWU7RUFDZixrQkFBa0I7RUFDbEIsa0JBQWtCO0VBQ2xCLFdBQVc7RUFDWCxZQUFZO0FBQ2Q7O0FBRUE7RUFDRSx5QkFBeUI7QUFDM0I7QUFDQTtFQUNFLFlBQVk7RUFDWixhQUFhO0VBQ2IseUJBQXlCO0VBQ3pCLGdCQUFnQjtFQUNoQiwwQkFBMEI7QUFDNUI7O0FBRUE7RUFDRSx3RUFBd0U7QUFDMUU7QUFDQTtFQUNFLFVBQVU7RUFDVixpQkFBaUI7RUFDakIsZ0JBQWdCLEVBQUUscUJBQXFCO0FBQ3pDO0FBQ0E7RUFDRSxnQkFBZ0I7RUFDaEIsaUJBQWlCO0FBQ25CIiwiZmlsZSI6InRlbXBvcmFyeS1kb2EtZGVzaWduZWUuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbImJvZHkge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZXNtb2tlO1xufVxuXG4vKiBzdHlsZXMuY3NzICovXG4uaGVhZGluZy1ib3gge1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjRjFGMUYxO1xuICBib3JkZXI6IHNvbGlkIDFweCAjZDRkNGQ0O1xuICBtYXJnaW4tYm90dG9tOiA1MHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjMTg3YTliO1xuICBjb2xvcjogd2hpdGU7XG4gIHBhZGRpbmc6IDEwcHg7XG4gIGJvcmRlci1yYWRpdXM6IDVweCA1cHggMCAwO1xuICBkaXNwbGF5OiBibG9jaztcbiAgd2lkdGg6IDEwMCU7XG4gIGJveC1zaXppbmc6IGJvcmRlci1ib3g7XG59XG5cbi5DdXJyZW50RGVzaWduZWUge1xuICBib3JkZXI6IDJweCBzb2xpZCAjMjg2MDkwO1xuICB3aWR0aDogMTAwJTtcbiAgbWFyZ2luOiA1JSBhdXRvO1xuICBib3JkZXItcmFkaXVzOiAxMHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmZmO1xuICBwYWRkaW5nLWJvdHRvbToyJSBhdXRvO1xufVxuXG4uc2VhcmNoLWJ1dHRvbiB7XG4gIGJhY2tncm91bmQtY29sb3I6ICMxODdhOWI7XG4gIGNvbG9yOiB3aGl0ZTtcbiAgcGFkZGluZzogM3B4IDE1cHg7XG4gIGJvcmRlci1yYWRpdXM6IDVweDtcbiAgY3Vyc29yOiBwb2ludGVyO1xuICBtYXJnaW4tbGVmdDogMTBweDtcbn1cblxuLnNlYXJjaC1idXR0b246ZGlzYWJsZWQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjMTg3YTliO1xuICBjdXJzb3I6IG5vdC1hbGxvd2VkO1xufVxuXG5cblxuLyogR2VuZXJhbCB0YWJsZSBzdHlsZXMgKi9cbnRhYmxlIHtcbiAgYm9yZGVyLWNvbGxhcHNlOiBjb2xsYXBzZTtcbiAgd2lkdGg6IDEwMCU7XG5cbn1cblxudGgsXG50ZCB7XG4gIGJvcmRlcjogMXB4IHNvbGlkIGdyZXk7XG4gIHBhZGRpbmc6IDJweDtcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xuICBoZWlnaHQ6IDMwcHg7XG59XG5cbnRoIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogI2YyZjJmMjtcbn1cblxuLyogU3BlY2lmaWMgc3R5bGVzIGZvciB0aGUgbmVzdGVkIHRhYmxlICovXG4uaGVhZGluZy1ib3grdGFibGUge1xuICBib3JkZXI6IDFweCBzb2xpZCBncmV5O1xufVxuXG4uaGVhZGluZy1ib3grdGFibGUgdGgsXG4uaGVhZGluZy1ib3grdGFibGUgdGQge1xuICBib3JkZXI6IDFweCBzb2xpZCBncmV5O1xuICBwYWRkaW5nOiA1cHg7XG4gIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgaGVpZ2h0OiAxMHB4O1xufVxuXG5cblxuXG4vKiBNb2RhbCBzdHlsZXMgKi9cbi5tb2RhbCB7XG4gIGRpc3BsYXk6IG5vbmU7XG4gIHBvc2l0aW9uOiBmaXhlZDtcbiAgei1pbmRleDogMTtcbiAgbGVmdDogNTAlO1xuICB0b3A6IDUwJTtcbiAgdHJhbnNmb3JtOiB0cmFuc2xhdGUoLTUwJSwgLTUwJSk7XG4gIHdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IDEwMCU7XG4gIG92ZXJmbG93OiBhdXRvO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiB0cmFuc3BhcmVudDtcbn1cblxuLm1vZGFsLWNvbnRlbnQge1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjZmVmZWZlO1xuICBtYXJnaW46IGF1dG87XG4gIHBhZGRpbmc6IDIwcHg7XG4gIGJvcmRlcjogMXB4IHNvbGlkICM4ODg7XG4gIHdpZHRoOiA4MCU7XG4gIG1heC13aWR0aDogNTAwcHg7XG4gIGhlaWdodDogYXV0bztcbiAgbWF4LWhlaWdodDogMzAwcHg7XG4gIG92ZXJmbG93LXk6IGF1dG87XG4gIGJveC1zaGFkb3c6IDAgNHB4IDhweCAwIHJnYmEoMCwgMCwgMCwgMC4yKSwgMCA2cHggMjBweCAwIHJnYmEoMCwgMCwgMCwgMC4xOSk7XG59XG5cblxuLyogT0sgYnV0dG9uIHN0eWxlcyAqL1xuI2Nsb3NlU3VjY2Vzc01vZGFsIHtcbiAgYmFja2dyb3VuZC1jb2xvcjogIzAwN2JmZjtcbiAgY29sb3I6IHdoaXRlO1xuICBib3JkZXI6IG5vbmU7XG4gIHBhZGRpbmc6IDVweCAxMHB4O1xuICB0ZXh0LWFsaWduOiByaWdodDtcbiAgdGV4dC1kZWNvcmF0aW9uOiBub25lO1xuICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gIGZvbnQtc2l6ZTogMTRweDtcbiAgbWFyZ2luOiAxMHB4IDA7XG4gIGN1cnNvcjogcG9pbnRlcjtcbiAgYm9yZGVyLXJhZGl1czogNHB4O1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIHJpZ2h0OiAyMHB4O1xuICBib3R0b206IDIwcHg7XG59XG5cbiNjbG9zZVN1Y2Nlc3NNb2RhbDpob3ZlciB7XG4gIGJhY2tncm91bmQtY29sb3I6ICMwMDU2YjM7XG59XG4uY3VycmVudGRlc2lnbmVlLXNlbGVjdC10ZXh0IHtcbiAgY29sb3I6IHdoaXRlO1xuICBwYWRkaW5nOiAxMHB4O1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAjMjg2MDkwO1xuICB0ZXh0LWFsaWduOiBsZWZ0O1xuICBib3JkZXItcmFkaXVzOiA1cHggNXB4IDAgMDtcbn1cblxuOmhvc3Qge1xuICBmb250LWZhbWlseTogXCJHb3RoYW1Cb2xkXCIsIFwiSGVsdmV0aWNhIE5ldWVcIiwgSGVsdmV0aWNhLEFyaWFsLCBzYW5zLXNlcmlmO1xufVxuLmRlc2lnbmVlLW1lc3NhZ2Uge1xuICBjb2xvcjogcmVkO1xuICB0ZXh0LWFsaWduOiByaWdodDtcbiAgbWFyZ2luLXRvcDogMTBweDsgLyogQWRqdXN0IGFzIG5lZWRlZCAqL1xufVxuLnRhYmxle1xuICBwYWRkaW5nLWxlZnQ6IDIlO1xuICBwYWRkaW5nLXJpZ2h0OiAyJTtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/doa/temporary-doa-designee/temporary-doa-designee.component.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,cAAc;EACd,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;;;AAIA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,WAAW;;AAEb;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;AACzC;EACE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;;;;AAKA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,4EAA4E;AAC9E;;;AAGA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wEAAwE;AAC1E;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB,EAAE,qBAAqB;AACzC;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA,gxKAAgxK","sourcesContent":["body {\n  background-color: whitesmoke;\n}\n\n/* styles.css */\n.heading-box {\n  text-align: left;\n  background-color: #F1F1F1;\n  border: solid 1px #d4d4d4;\n  margin-bottom: 50px;\n  background-color: #187a9b;\n  color: white;\n  padding: 10px;\n  border-radius: 5px 5px 0 0;\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.CurrentDesignee {\n  border: 2px solid #286090;\n  width: 100%;\n  margin: 5% auto;\n  border-radius: 10px;\n  background-color: #fff;\n  padding-bottom:2% auto;\n}\n\n.search-button {\n  background-color: #187a9b;\n  color: white;\n  padding: 3px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.search-button:disabled {\n  background-color: #187a9b;\n  cursor: not-allowed;\n}\n\n\n\n/* General table styles */\ntable {\n  border-collapse: collapse;\n  width: 100%;\n\n}\n\nth,\ntd {\n  border: 1px solid grey;\n  padding: 2px;\n  text-align: center;\n  height: 30px;\n}\n\nth {\n  background-color: #f2f2f2;\n}\n\n/* Specific styles for the nested table */\n.heading-box+table {\n  border: 1px solid grey;\n}\n\n.heading-box+table th,\n.heading-box+table td {\n  border: 1px solid grey;\n  padding: 5px;\n  text-align: center;\n  height: 10px;\n}\n\n\n\n\n/* Modal styles */\n.modal {\n  display: none;\n  position: fixed;\n  z-index: 1;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: transparent;\n}\n\n.modal-content {\n  background-color: #fefefe;\n  margin: auto;\n  padding: 20px;\n  border: 1px solid #888;\n  width: 80%;\n  max-width: 500px;\n  height: auto;\n  max-height: 300px;\n  overflow-y: auto;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n\n/* OK button styles */\n#closeSuccessModal {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  text-align: right;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 14px;\n  margin: 10px 0;\n  cursor: pointer;\n  border-radius: 4px;\n  position: absolute;\n  right: 20px;\n  bottom: 20px;\n}\n\n#closeSuccessModal:hover {\n  background-color: #0056b3;\n}\n.currentdesignee-select-text {\n  color: white;\n  padding: 10px;\n  background-color: #286090;\n  text-align: left;\n  border-radius: 5px 5px 0 0;\n}\n\n:host {\n  font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n}\n.designee-message {\n  color: red;\n  text-align: right;\n  margin-top: 10px; /* Adjust as needed */\n}\n.table{\n  padding-left: 2%;\n  padding-right: 2%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
